// Textvorlagen je Belegart (Ralph 22.10.2026): passende Texte zuerst, Standardtext automatisch.
// Die Regel, welcher Text Standard ist, steht einmal im Server (module_textvorlagen/routes.py: standard_vorlage).
import { api } from "@/lib/api";

// Texte, die zu einer Belegart gehören (Rest wie Titel, Bemerkung gilt überall)
export const TEXTE_JE_BELEGART = ["vortext", "schlusstext", "betreff", "email"];

export const BELEGART_NAME = { angebot: "Angebot", auftrag: "Auftragsbestätigung", rechnung: "Rechnung", allgemein: "Allgemein" };

// Passt die Vorlage zur Belegart? Eigene Belegart oder „Allgemein“.
export const passtZurBelegart = (t, docType) =>
  !docType || !TEXTE_JE_BELEGART.includes(t.text_type) || t.doc_type === docType || t.doc_type === "allgemein";

// Standardvorlage (roher Inhalt mit Platzhaltern) oder null
export const ladeStandardVorlage = async (docType, textType) => {
  try {
    const res = await api.get("/modules/textvorlagen/standard", { params: { doc_type: docType, text_type: textType } });
    return res.data || null;
  } catch {
    return null;
  }
};
